import React from "react";

interface Props {
  name: string;
}

export const Author: React.FC<React.PropsWithChildren<Props>> = ({ name }) => {
  return <p>Skrevet av: {name}</p>;
};
